<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'

// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(
  require('@fortawesome/free-solid-svg-icons/faInfoCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faSync').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowRight').definition,
  require('@fortawesome/free-solid-svg-icons/faRegistered').definition,
  require('@fortawesome/free-solid-svg-icons/faUser').definition,
  require('@fortawesome/free-solid-svg-icons/faHome').definition,
  require('@fortawesome/free-solid-svg-icons/faSearch').definition,
  require('@fortawesome/free-solid-svg-icons/faDownload').definition,
  require('@fortawesome/free-solid-svg-icons/faPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faPlusSquare').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faPencilAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faEdit').definition,
  require('@fortawesome/free-solid-svg-icons/faEnvelope').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendar').definition,
  require('@fortawesome/free-solid-svg-icons/faEye').definition,
  require('@fortawesome/free-solid-svg-icons/faEyeSlash').definition,
  require('@fortawesome/free-solid-svg-icons/faFilePdf').definition,
  require('@fortawesome/free-solid-svg-icons/faChartLine').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleDoubleRight').definition,
  require('@fortawesome/free-solid-svg-icons/faLink').definition,
  require('@fortawesome/free-solid-svg-icons/faCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faCheckCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleRight').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleLeft').definition,
  require('@fortawesome/free-solid-svg-icons/faLock').definition,
  require('@fortawesome/free-solid-svg-icons/faTrash').definition,
  require('@fortawesome/free-solid-svg-icons/faTimesCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faFolderOpen').definition,
  require('@fortawesome/free-solid-svg-icons/faSave').definition,
  require('@fortawesome/free-solid-svg-icons/faInfoCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faUpload').definition,
  require('@fortawesome/free-solid-svg-icons/faCopy').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowUp').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowDown').definition,
  require('@fortawesome/free-solid-svg-icons/faDollarSign').definition,
  require('@fortawesome/free-solid-svg-icons/faCommentDots').definition,
  require('@fortawesome/free-solid-svg-icons/faChartLine').definition,
  require('@fortawesome/free-solid-svg-icons/faCalendarAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faBriefcase').definition,
  require('@fortawesome/free-solid-svg-icons/faGavel').definition,
  require('@fortawesome/free-solid-svg-icons/faStar').definition,
  require('@fortawesome/free-solid-svg-icons/faFileInvoice').definition,
  require('@fortawesome/free-solid-svg-icons/faDiceD20').definition,
  require('@fortawesome/free-solid-svg-icons/faThumbtack').definition,
  require('@fortawesome/free-solid-svg-icons/faExpand').definition,
  require('@fortawesome/free-solid-svg-icons/faCompress').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarkerAlt').definition,

  require('@fortawesome/free-solid-svg-icons/faTimesCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faExternalLinkSquareAlt')
    .definition,
  require('@fortawesome/free-solid-svg-icons/faCogs').definition,
  require('@fortawesome/free-solid-svg-icons/faFolderPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faEllipsisV').definition,
  require('@fortawesome/free-solid-svg-icons/faListUl').definition,
  require('@fortawesome/free-solid-svg-icons/faChartArea').definition,
  require('@fortawesome/free-solid-svg-icons/faFileExcel').definition,
  require('@fortawesome/free-solid-svg-icons/faUpload').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleDoubleDown').definition,
  require('@fortawesome/free-solid-svg-icons/faAngleDoubleUp').definition,
  require('@fortawesome/free-solid-svg-icons/faClock').definition,
  require('@fortawesome/free-solid-svg-icons/faBell').definition,
  require('@fortawesome/free-solid-svg-icons/faCaretRight').definition,
  require('@fortawesome/free-solid-svg-icons/faCaretDown').definition,
  require('@fortawesome/free-solid-svg-icons/faWrench').definition,
  require('@fortawesome/free-solid-svg-icons/faFileCsv').definition,
  require('@fortawesome/free-solid-svg-icons/faFile').definition
)
export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: 'font-awesome',
    },
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>

<template>
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="name"
    :class="$style.customIconClass"
    v-on="$listeners"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="$style.customIconClass"
    v-on="$listeners"
  />
</template>
<style lang="scss" module>
@import '@design';

.customIconClass {
  // cursor: pointer;
}
</style>
